import React from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import '@fortawesome/fontawesome-free/css/all.css';

import './index.css';
import App from './App';

const root = createRoot(document.getElementById('root'));

{/* <React.StrictMode>
</React.StrictMode> */}

root.render(
    <App />
);